<script src="./App.js"></script>
<template src="./App.pug"></template>
<style src="./App.scss"></style>